export const actions = {
  setPageTitle: 'SET_PAGE_TITLE',
};

export function setPageTitle(title, info) {
  return { type: actions.setPageTitle, title, info };
}

const INITIAL_STATE = {
  title: '',
};

export default function reducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case actions.setPageTitle:
      return {
        ...state,
        title: action.title,
        info: action.info,
      };
    default:
      return {
        ...state,
      };
  }
}
